import { Card } from 'components/Card';
import { ErrorState } from 'components/error-state/ErrorState';
import { PageHeader } from 'components/PageHeader';
import { DelayedSpinner } from 'components/Spinner';
import { StatCard } from 'components/stat-card/StatCard';
import useSWR from 'swr';

import { TrailersHeading } from '../components/TrailersHeading';
import { getTrailerOverview, TRAILER_OVERVIEW_SWR_KEY } from '../models';

export const TrailersOverviewPage = () => {
  const { data, error, mutate } = useSWR([TRAILER_OVERVIEW_SWR_KEY], getTrailerOverview);

  return (
    <>
      <PageHeader title="Trailers" />

      <TrailersHeading />

      <div className="flex flex-col gap-4 px-7 py-5">
        {error && !data ? (
          <ErrorState error={error} variant="section" onRetry={() => mutate()} />
        ) : !data ? (
          <DelayedSpinner className="flex items-center justify-center py-8" size={8} />
        ) : (
          <>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
              <StatCard label="Totaal" value={data.total} subValue={`${data.owned} eigen · ${data.rental} huur`} />
              <StatCard label="Actief" value={data.active} subValue={`${data.total - data.active} inactief`} />
              <StatCard label="Eigen" value={data.owned} />
              <StatCard label="Huurtrailer" value={data.rental} subValue={`${data.activeRental} actief`} />
              <StatCard label="Tautliner" value={data.tautliner} />
              <StatCard label="Mega" value={data.mega} />
            </div>

            {data.byRentalCompany.length > 0 && (
              <Card title="Per verhuurmaatschappij">
                <div className="flex flex-col gap-2">
                  {data.byRentalCompany.map((row) => (
                    <div
                      key={row.company ?? 'unknown'}
                      className="flex items-center justify-between gap-4 border-b border-border py-1 last:border-b-0"
                    >
                      <span className="text-fg-secondary">{row.company ?? 'Onbekend'}</span>
                      <span className="font-medium text-fg">{row.count}</span>
                    </div>
                  ))}
                </div>
              </Card>
            )}
          </>
        )}
      </div>
    </>
  );
};
